/**
 * Landing Page
 * Thin connector that wires up the ViewModel to the View
 * Following MVVM - this is the "glue" layer
 */

import { LandingView, useLandingViewModel } from "../features/landing";

export function LandingPage() {
  // ViewModel handles ALL business logic
  const viewModel = useLandingViewModel({
    config: {
      appName: "Callee",
    },
    appStoreConfig: {
      playStoreUrl:
        "https://play.google.com/store/apps/details?id=com.neobhi.neocc.mobile",
    },
  });

  // View is purely presentational
  return <LandingView viewModel={viewModel} />;
}
